import Vue from 'vue'
import VueMeta from 'vue-meta'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import enLang from 'element-ui/lib/locale/lang/en' // 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import locale from 'element-ui/lib/locale/lang/zh-TW' //

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import socket from './utils/socket'
import socketGroup from './utils/socketGroup'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import * as VueGoogleMaps from 'vue2-google-maps'
console.log('VUE_APP_MAP_KEY', process.env.VUE_APP_MAP_KEY)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: 'places',
  },
  installComponents: true,
})
Vue.prototype.$socket = socket
Vue.prototype.$socketGroup = socketGroup
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
Vue.use(VueMeta)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: locale, // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://46e896513c5a659240d0a9209455f450@o4507384354635776.ingest.us.sentry.io/4507384395005952',
    release: '0.0.1',
    integrations: [
      new Sentry.BrowserTracing({
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        tracePropagationTargets: ['localhost', 'https://admin.itainctw.com/', /^\//],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    logErrors: true,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
